import React from 'react';
import './TextBookImages.css';

const TextBookImages = (props) => {
  return (
    <>
      <h1 className='bookLabel'>{props.form ? `${props.form} Form Textbooks` : ''} </h1>
      <div className='textBookImages'>
        {props.images.map((image) => (
          <img key={image.id} className='bookImage' src={image.bookImage} alt='Form Textbooks' />
        ))}
      </div>
    </>
  );
}

export default TextBookImages;
